export default __webpack_public_path__ + "static/media/green-solid.1da4a497.svg";